export default __webpack_public_path__ + "302de30c36a0b9ae25c2903230ee7bf5.svg";